import axios from "axios";
import { useEffect, useState } from "react";

import { getCourses } from "../api/courseApi";
import type { Course } from "../types";

// Loads the course list once
export const useCourses = () => {
    const [courses, setCourses] = useState<Course[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const controller = new AbortController();

        getCourses(controller.signal)
            .then(setCourses)
            .catch((err) => {
                if (axios.isCancel(err)) return; // Page was left, not a real error
                console.error("Error fetching courses:", err);
                setError(true);
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, []);

    return { courses, loading, error };
};